import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';
import { MuiAccordion, MuiAccordionDetails, MuiAccordionSummary } from './accordion';
import { MuiAvatar } from './avatar';
import { MuiButton } from './button';
import { MuiCard } from './card';
import { MuiCardContent } from './card-content';
import { MuiCardHeader } from './card-header';
import { MuiLink } from './link';
import { MuiStack } from './stack';
import {
  MuiAlert,
  MuiAppBar,
  MuiCheckbox,
  MuiChip,
  MuiDialog,
  MuiDivider,
  MuiDrawer,
  MuiIconButton,
  MuiInputLabel,
  MuiListItemButton,
  MuiMenu,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPaper,
  MuiPopover,
  MuiSwitch,
  MuiTableRow,
  MuiTooltip,
} from './surfaces';
import { MuiTab } from './tab';
import { MuiSelect, MuiTabs } from './tabs';
import { MuiTableBody } from './table-body';
import { MuiTableCell } from './table-cell';
import { MuiTableHead } from './table-head';

export const components = {
  MuiAccordion,
  MuiAccordionSummary,
  MuiAccordionDetails,
  MuiAlert,
  MuiAppBar,
  MuiAvatar,
  MuiButton,
  MuiCard,
  MuiCardContent,
  MuiCardHeader,
  MuiCheckbox,
  MuiChip,
  MuiDialog,
  MuiDivider,
  MuiDrawer,
  MuiIconButton,
  MuiInputLabel,
  MuiLink,
  MuiListItemButton,
  MuiMenu,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPaper,
  MuiPopover,
  MuiSelect,
  MuiStack,
  MuiSwitch,
  MuiTab,
  MuiTabs,
  MuiTableBody,
  MuiTableCell,
  MuiTableHead,
  MuiTableRow,
  MuiTooltip,
} satisfies Components<Theme>;
